module.exports = __webpack_public_path__ + "dcf33fa1018134c26398b0622956d0a7.jpg";